var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"{ backgroundColor":"#003366}"},attrs:{"id":"app"}},[_c('div',{attrs:{"id":"week"}},[_vm._v(" "+_vm._s(_vm.week)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }